export default __webpack_public_path__ + "static/media/logo2.42654806.svg";